import React from 'react'
import styled from 'styled-components'
import { Property } from 'csstype'

import { Box, BoxProps } from 'components/styled/containers/box'
import { ThemeSpace } from 'theme/spaces'

const StyledFlex = styled(Box)<{
  $justifyContent?: Property.JustifyContent
  $flexDirection?: Property.FlexDirection
  $alignItems?: Property.AlignItems
  $flexWrap?: Property.FlexWrap
  $gap?: ThemeSpace
}>`
  display: flex;
  justify-content: ${({ $justifyContent }) => $justifyContent};
  flex-direction: ${({ $flexDirection }) => $flexDirection};
  align-items: ${({ $alignItems }) => $alignItems};
  flex-wrap: ${({ $flexWrap }) => $flexWrap};
  gap: ${({ $gap, theme }) => ($gap ? theme.space[$gap] : 0)};
`

export interface FlexProps extends BoxProps {
  justifyContent?: Property.JustifyContent
  flexDirection?: Property.FlexDirection
  alignItems?: Property.AlignItems
  flexWrap?: Property.FlexWrap
  gap?: ThemeSpace
}

export const Flex: React.FC<FlexProps> = ({
  justifyContent,
  flexDirection,
  alignItems,
  gap,
  flexWrap,
  children,
  ...props
}) => {
  return (
    <StyledFlex
      $justifyContent={justifyContent}
      $flexDirection={flexDirection}
      $alignItems={alignItems}
      $gap={gap}
      $flexWrap={flexWrap}
      {...props}
    >
      {children}
    </StyledFlex>
  )
}
